var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinterestGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39623 13.2274C5.87023 15.9814 5.22923 18.6214 3.32823 20.0004C2.74223 15.8384 4.18923 12.7134 4.86223 9.39543C3.71523 7.46543 5.00023 3.58343 7.41723 4.54043C10.3922 5.71643 4.84123 11.7124 8.56723 12.4624C12.4582 13.2434 14.0462 5.71243 11.6332 3.26343C8.14823 -0.274572 1.48723 3.18043 2.30723 8.24543C2.50623 9.48343 3.78523 9.85843 2.81823 11.5674C0.587231 11.0734 -0.078769 9.31343 0.00723097 6.96743C0.145231 3.12743 3.45623 0.440428 6.77823 0.0674279C10.9792 -0.403572 14.9222 1.61043 15.4672 5.56143C16.0802 10.0224 13.5712 14.8544 9.07823 14.5064C7.86023 14.4114 7.35023 13.8074 6.39623 13.2274Z",
    fill: "url(#paint0_linear_87_451)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_451",
    x1: 0.225618,
    y1: 14.3014,
    x2: 3.77082,
    y2: 14.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315771,
    stopColor: "#30BDE3",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D82AFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterestGradient);
export default __webpack_public_path__ + "static/media/printerest-gradient.0510bb07f93aca09ddf090a6cabdac30.svg";
export { ForwardRef as ReactComponent };